import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
      {categories.map((cat) => (
        <a
          key={cat.name}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="flex flex-col rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-background-100 transition-all group cursor-pointer overflow-hidden"
        >
          <div className="w-full aspect-[4/3] overflow-hidden bg-background-100">
            <div
              className="w-full h-full bg-cover bg-center group-hover:scale-105 transition-transform duration-300"
              style={{ backgroundImage: `url('${cat.image}')` }}
            />
          </div>
          <div className="flex items-center gap-2 p-3 md:p-3.5">
            <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200 transition-colors">
              <i className={`${cat.icon} w-4 h-4 flex items-center justify-center text-accent-600`}></i>
            </div>
            <span
              className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors leading-tight line-clamp-2"
              dangerouslySetInnerHTML={{ __html: cat.name }}
            />
          </div>
        </a>
      ))}
    </div>
  );
}